var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51943 4.83975C9.51943 4.83975 3.48234 6.45738 6.39649 17.3331L5.51287 18.8651C6.38306 22.1127 23.3072 17.6588 22.4167 14.3357L20.8855 13.4508C17.9714 2.57506 11.9343 4.19269 11.9343 4.19269C11.5194 2.64436 9.09445 3.25368 9.51943 4.83975Z",
    fill: "#FDDF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3681 20.87C13.4974 24.2134 18.166 22.9219 18.3485 18.9996C16.1436 19.9021 13.7288 20.5492 11.3681 20.87Z",
    fill: "#FDDF6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastBell);
export default __webpack_public_path__ + "static/media/toastBell.9082cbf15f3abdbba1212a2261cca91b.svg";
export { ForwardRef as ReactComponent };